let initialState = {
    words: ['UK', 'USA', 'IT'],
}

const ignoreList = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_WORD':
            return {
                words: [...state.words, action.data],
            }
        default:
            return state
    }
}

export default ignoreList
